import * as React from "react";
import { usePerformAction, useDataLoader } from "react-remote-data-hooks";
import api from "../../../../api";
import {
  NotificationSettings,
  convertPascalCaseToWords,
  ITemplateKeyItem,
} from "../../../../core";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import UpdateForm from "./UpdateForm";

interface IQuotationSettingsProps {
  data?: NotificationSettings;
  reload?: () => void;
}

const NotificationSettingsTab: React.FunctionComponent<IQuotationSettingsProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: NotificationSettings) =>
      api.settings.updateNotificationSettings({
        ...data,
        appoinmentReminderTriggerInMinutes: Number(
          data.appoinmentReminderTriggerInMinutes
        ),
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
      appSettings.reload();
    }
  );

  const { data: templates } = useDataLoader<ITemplateKeyItem[]>(() =>
    api.settings.getTemplateKeys()
  );

  const { data: events } = useDataLoader<ITemplateKeyItem[]>(() =>
    api.settings.getEventKeys()
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Notification Settings</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Type</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Enabled Templates
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>SMS</td>
                <td>
                  {props.data?.smsEnabledTemplates?.map((template, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(
                          templates?.find((x) => x.key === template)?.name ||
                            template
                        )}
                        {index !==
                          (props.data?.smsEnabledTemplates?.length || 1) -
                            1 && <>, </>}
                      </>
                    );
                  })}
                </td>
              </tr>

              <tr>
                <td> Email Enabled</td>
                <td>
                  {props.data?.emailEnabledTemplates?.map((template, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(
                          templates?.find((x) => x.key === template)?.name ||
                            template
                        )}
                        {index !==
                          (props.data?.emailEnabledTemplates?.length || 1) -
                            1 && <>, </>}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td> Cc Enabled</td>
                <td>
                  {props.data?.ccEnabledEvents?.map((event, index) => {
                    return (
                      <>
                        {convertPascalCaseToWords(
                          events?.find((x) => x.key === event)?.name || event
                        )}
                        {index !==
                          (props.data?.ccEnabledEvents?.length || 1) - 1 && (
                          <>, </>
                        )}
                      </>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>
                  {" "}
                  Enable Email To Support Executive For Assign
                  SalesPerson?
                </td>
                <td>
                  {props.data?.enableCCEmailToCrmAgentForAssignSalesPerson
                    ? "Yes"
                    : "No"}
                </td>
              </tr>
              {/* <tr>
                <td> Enable Email To Support Executive For Test Drive?</td>
                <td>
                  {props.data?.enableCCEmailToCrmAgentForTestDrive
                    ? "Yes"
                    : "No"}
                </td>
              </tr> */}
              <tr>
                <td>
                  {" "}
                  Enable Email To Support Executive For Showroom
                  Visit?
                </td>
                <td>
                  {props.data?.enableCCEmailToCrmAgentForShowroomVisit
                    ? "Yes"
                    : "No"}
                </td>
              </tr>
              <tr>
                <td> Converted To Enquiry Email/Sms Recipient UserTypes</td>
                <td>
                  {props.data?.convertedToEnquiryEmailSmsRecipientsUserTypes?.join()}
                </td>
              </tr>
              <tr>
                <td> Appoinment Reminder Trigger In Minutes</td>
                <td>
                  {props.data?.appoinmentReminderTriggerInMinutes || 1440}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
              templates={templates}
              events={events}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default NotificationSettingsTab;
